import React, { useEffect } from 'react';
const ACUITY_SCRIPT_SRC = 'https://embed.acuityscheduling.com/js/embed.js';
const ACUITY_BOOKING_URL = 'https://app.acuityscheduling.com/schedule.php?owner=20909820&appointmentType=98927793';
const THANK_YOU_URL = 'https://weddings.twentymile-house.com/thank-you';
export function TourBooking() {
  // Load Acuity's embed script (handles auto-resizing of the calendar).
  useEffect(() => {
    document.querySelectorAll(`script[src="${ACUITY_SCRIPT_SRC}"]`).forEach(node => node.remove());
    const script = document.createElement('script');
    script.src = ACUITY_SCRIPT_SRC;
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);

  // Acuity posts an "AcuityEvent" message after every booking (Custom Conversion Tracking).
  // Listen for it and send the couple to the thank-you page.
  useEffect(() => {
    function handleMessage(e: MessageEvent) {
      let d: unknown = e.data;
      try {
        if (typeof d === 'string') d = JSON.parse(d);
      } catch (x) {
        return;
      }
      if (d && typeof d === 'object' && (d as {
        event?: unknown;
      }).event === 'AcuityEvent') {
        window.location.href = THANK_YOU_URL;
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
  return <section className="mx-auto mt-6 max-w-4xl px-4 md:px-6" aria-labelledby="tour-booking-heading" data-id="element-59" data-mp="3g44um9vj86mw">
      <h2 id="tour-booking-heading" className="mb-6 text-center font-display text-xl italic leading-snug text-ink" data-id="element-60" data-mp="3b7o7nj02jybe">
        Book a virtual tour below.
        <span className="mx-auto mt-2 block max-w-2xl font-body text-[15px] not-italic leading-relaxed text-ink/70" data-id="element-61" data-mp="325ooak1l0i5a">
          Once you’re booked, our full pricing and package guide will unlock for you to explore
          before your tour.
        </span>
      </h2>
      <iframe src={ACUITY_BOOKING_URL} title="Schedule your virtual tour" width="100%" height="800" frameBorder="0" allow="payment" data-id="element-62" data-mp="1qp83scb67bbk" />
    </section>;
}